import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';

import { Light } from 'themes';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import PanelModal from 'zignal-landscape/lib/PanelModal';
import BaseWizardContent from './BaseWizardContent';
import CancelModal from 'containers/BaseWizard/components/CancelModal';

import * as actions from './BaseWizard.slice';

export const mapStateToProps = (
  (state) => ({
    currentViewIndex: state.BaseWizard.currentViewIndex
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const BaseWizard = ({
  enableCancelModal,
  cancelModalProps = {},
  onClose = noop,
  ...rest
}) => {

  const {
    wizardStore: { isOpen } = {}
  } = rest;

  // create cancelModal if enabled (default is true)
  let onCancel = onClose;
  let cancelModal;
  if (enableCancelModal) {
    const [ isCancelModalOpen, setIsCancelModalOpen ] = useState(false);
    onCancel = () => setIsCancelModalOpen(true);
    const closeCancelModal = () => setIsCancelModalOpen(false);
    const confirmCancelModal = () => {
      closeCancelModal();
      onClose();
    };
    cancelModal = (
      <CancelModal
        {...cancelModalProps}
        isOpen={isCancelModalOpen}
        onConfirm={confirmCancelModal}
        onCancel={closeCancelModal}
      />
    );
  }

  return (
    <ThemeProvider theme={Light}>
      <PanelModal onCloseClick={onCancel} isOpen={isOpen}>
        <BaseWizardContent {...rest} onCancel={onCancel} />
      </PanelModal>
      {cancelModal}
    </ThemeProvider>
  );
};

BaseWizard.propTypes = {
  children: PropTypes.node,
  currentViewIndex: PropTypes.number,
  enableCancelModal: PropTypes.bool,
  cancelModalProps: PropTypes.object,
  onClose: PropTypes.func
};

export default connect(mapStateToProps, actions, mergeProps)(BaseWizard);
